// i18n plugin, leveraging react-i18next

import i18n, { InitOptions } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

const options: InitOptions = {
  fallbackLng: "fr",
  load: "languageOnly", // we only provide en, de -> no region specific locals like en-US, de-DE
  preload: ["fr", "en"],
  whitelist: ["fr", "en"],

  // Common namespace for all classic things: buttons, link, etc...
  defaultNS: "common",
  ns: ["common"],

  debug: true,

  interpolation: {
    escapeValue: false // React already does escaping
  },

  backend: {
    loadPath: `locales/{{lng}}/{{ns}}.json` // locales folder has to be served by gatsby, this is done in gatsby-config.js
  },

  react: {
    wait: true // React has to wait for loadspace to be loaded before rendering
  }
};

/**
 * This is browser client, it's options are overrided in server rendering step, see gatsby-ssr.js
 */
i18n
  .use(XHR) // XHR plugins is responsible for loading namespaces browser side, according to "backend" option above
  .use(LanguageDetector) // Tries to detect user language based on browser
  .init(options);

/**
 * Helpers
 */

/**
 * Return active language from i18n.
 */
export function getCurrentLanguage() {
  return i18n.language;
}

/**
 * Return available languages in i18n
 * Actually, it's the whitelist array
 */
export function getAvailableLanguages() {
  return i18n.options.preload;
}

/**
 * Return fallback language (i.e default) in i18n
 */
export function getDefaultLanguage() {
  return "fr"; // i18n.options.fallbackLng[0];
}

export default i18n;



// WEBPACK FOOTER //
// ./src/plugins/i18nextPlugin.tsx